import { render, staticRenderFns } from "./lecture-list-title.vue?vue&type=template&id=6983a192"
import script from "./lecture-list-title.vue?vue&type=script&lang=js"
export * from "./lecture-list-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports